import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logos/square.svg'


const _hoisted_1 = {
  class: "app-loader",
  "data-cy": "app-loader"
}
const _hoisted_2 = {
  key: 0,
  class: "lds-ripple"
}

import { ref, computed, onMounted, onBeforeUnmount } from "vue";

interface Props {
  ripple?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VLoader',
  props: {
    ripple: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const showLogo = ref(false);
const interval = ref<number>(0);

const logoClasses = computed(() => {
  return { show: showLogo.value };
});

const toggleLogo = () => {
  showLogo.value = !showLogo.value;
};

onMounted(() => {
  interval.value = setInterval(toggleLogo, 1000);
  setTimeout(() => (showLogo.value = true), 100);
});

onBeforeUnmount(() => {
  clearInterval(interval.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "loader" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: _normalizeClass(["loader-logo", logoClasses.value]),
            src: _imports_0,
            alt: "Blasto"
          }, null, 2)
        ]),
        (props.ripple)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
              _createElementVNode("div", null, null, -1),
              _createElementVNode("div", null, null, -1)
            ])))
          : _createCommentVNode("", true)
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})